
import { Link } from "react-router-dom";
import { getPlaceholderImage, getServiceIcon } from "@/utils/imageUtils";
import { ImageWithFallback } from "@/components/ui/image-with-fallback";

interface ContractorImageProps {
  imageUrl: string;
  name: string;
  serviceType: string;
  pageUrl: string;
  viewMode?: "grid" | "list";
}

export const ContractorImage = ({
  imageUrl,
  name,
  serviceType,
  pageUrl,
  viewMode = "grid",
}: ContractorImageProps) => {
  const finalImageUrl = imageUrl || getPlaceholderImage(serviceType);
  const IconComponent = getServiceIcon(serviceType);
  const altText = `${name} - Professional ${serviceType} Services in Oklahoma City`;

  console.log('ContractorImage rendering:', {
    name,
    serviceType,
    imageUrl,
    finalImageUrl,
    hasIconComponent: !!IconComponent
  });

  return (
    <Link
      to={pageUrl}
      className={`relative block overflow-hidden ${
        viewMode === "grid" 
          ? "aspect-[16/9] w-full" 
          : "w-48 aspect-[4/3]"
      }`}
    >
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#918FB6] via-[#919191] to-[#BFBFBF]" />
      
      {/* Shadow overlay for depth */}
      <div className="absolute inset-0 shadow-inner opacity-10" />
      
      {/* Main centering container */}
      <div className="absolute inset-0 flex items-center justify-center">
        {/* Padding container with fixed dimensions */}
        <div className="w-[80%] h-[80%] flex items-center justify-center">
          {/* Image or icon fallback wrapper */}
          <div className="relative w-full h-full flex flex-col items-center justify-center">
            <ImageWithFallback
              src={finalImageUrl}
              alt={altText}
              fallbackSrc={getPlaceholderImage(serviceType)}
              className="max-w-[95%] max-h-[95%] w-auto h-auto object-contain hover:scale-105 transition-transform duration-300"
              serviceType={serviceType}
            />
          </div>
        </div>
      </div>
    </Link>
  );
};
